/*
  Popup de suscripción (captura de leads) — <subscribe-popup>.
  Markup: sections/fibrolab-subscribe-popup.liquid · Estilos: assets/fibrolab-subscribe.css

  Hereda de ModalDialog (global.js): [open], overflow-hidden, trapFocus, ESC,
  click-en-backdrop y botón ModalClose-*. Aquí vive solo la lógica de disparo
  (móvil: tiempo/scroll · desktop: exit-intent + respaldo), la supresión en
  localStorage y el estado post-redirect del POST nativo (?customer_posted=true).

  Al volver con éxito se avisa además al CRM (POST /api/newsletter), que es
  quien manda el correo de bienvenida con el cupón vía Resend. Shopify guarda
  el contacto; el correo lo envía el CRM.

  La franja (fibrolab-subscribe-band) carga este mismo archivo por el botón
  copiar y el marcado de origen; el guard de abajo evita la doble ejecución.

  QA: ?fb-popup=open fuerza la apertura ignorando supresión y triggers.
*/
(function () {
  'use strict';
  if (window.__fbSubscribeInit) return;
  window.__fbSubscribeInit = true;

  var LS_SUBSCRIBED = 'fb_subscribed';
  var LS_DISMISSED = 'fb_subscribe_dismissed_at';
  var SS_ORIGIN = 'fb_subscribe_origin';
  var SS_EMAIL = 'fb_subscribe_email';
  var DAY_MS = 86400000;

  /* Base del CRM (mismo host que el widget del chat en layout/theme.liquid).
     Override para pruebas: window.FB_CRM_URL antes de cargar este script. */
  var CRM_URL = (window.FB_CRM_URL || 'https://crm.fibrolabstore.cl').replace(/\/+$/, '');

  /* El endpoint del CRM solo acepta estos orígenes; el resto va como 'otro'. */
  function crmOrigin(origin) {
    return origin === 'popup' || origin === 'band' || origin === 'footer' ? origin : 'otro';
  }

  /* Storage con try/catch (Safari private). Si no hay storage, fail-closed:
     mejor no mostrar el popup que mostrarlo en cada carga. */
  function lsGet(key) { try { return window.localStorage.getItem(key); } catch (e) { return '1'; } }
  function lsSet(key, value) { try { window.localStorage.setItem(key, value); } catch (e) { /* noop */ } }
  function ssGet(key) { try { return window.sessionStorage.getItem(key); } catch (e) { return null; } }
  function ssSet(key, value) { try { window.sessionStorage.setItem(key, value); } catch (e) { /* noop */ } }
  function ssRemove(key) { try { window.sessionStorage.removeItem(key); } catch (e) { /* noop */ } }

  /* Origen del último submit (popup/franja/footer): el POST nativo recarga la
     página, así que se anota en sessionStorage ANTES de que navegue. */
  var pendingOrigin = ssGet(SS_ORIGIN);

  /* Avisa al CRM para que mande el correo de bienvenida con el cupón (Resend).
     Se llama SOLO tras el éxito del POST de Shopify, así que la dirección ya
     pasó su validación y su anti-spam. text/plain lo mantiene como "petición
     simple" (sin preflight OPTIONS) y keepalive la deja completar aunque el
     visitante navegue enseguida. El CRM deduplica: una dirección recibe el
     correo de bienvenida una sola vez. Si falla, la suscripción en Shopify ya
     quedó hecha — no se reintenta ni se le muestra nada al visitante. */
  function notifyCrm(email, origin) {
    if (!email || !window.fetch) return;
    try {
      window
        .fetch(CRM_URL + '/api/newsletter', {
          method: 'POST',
          headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
          body: JSON.stringify({ email: email, origin: crmOrigin(origin) }),
          mode: 'cors',
          credentials: 'omit',
          keepalive: true,
        })
        .catch(function () { /* noop */ });
    } catch (e) { /* noop */ }
  }

  /* Éxito post-redirect: cualquier form 'customer' vuelve con ?customer_posted=true.
     Se marca fb_subscribed venga de donde venga (popup, franja o footer), se
     avisa al CRM y se limpia el param de la URL para que un refresh/compartir
     no re-dispare nada. */
  function detectPosted() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('customer_posted') !== 'true') return null;
    lsSet(LS_SUBSCRIBED, '1');
    var origin = ssGet(SS_ORIGIN) || 'unknown';
    ssRemove(SS_ORIGIN);
    var email = ssGet(SS_EMAIL);
    ssRemove(SS_EMAIL);
    notifyCrm(email, origin);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: 'fb_newsletter_signup', origin: origin });
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('customer_posted');
      window.history.replaceState({}, '', url.toString());
    } catch (e) { /* noop */ }
    return origin;
  }
  var postedOrigin = detectPosted();

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || !form.getAttribute) return;
      var origin = form.getAttribute('data-fb-origin');
      if (!origin && form.id === 'ContactFooter') origin = 'footer';
      if (!origin) return;
      ssSet(SS_ORIGIN, origin);
      /* La dirección se guarda aquí porque el POST nativo recarga la página:
         al volver con ?customer_posted=true ya no está en ningún input. */
      var input = form.querySelector('input[name="contact[email]"]');
      var email = input && input.value ? input.value.trim() : '';
      if (email) ssSet(SS_EMAIL, email);
      else ssRemove(SS_EMAIL);
    },
    true
  );

  /* Botón "Copiar código" (popup y franja) */
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-fb-copy]');
    if (!btn || !navigator.clipboard) return;
    navigator.clipboard
      .writeText(btn.getAttribute('data-fb-copy'))
      .then(function () {
        if (!btn.dataset.originalLabel) btn.dataset.originalLabel = btn.textContent;
        btn.textContent = btn.getAttribute('data-copied-label') || btn.textContent;
        btn.classList.add('is-copied');
        setTimeout(function () {
          btn.textContent = btn.dataset.originalLabel;
          btn.classList.remove('is-copied');
        }, 2500);
      })
      .catch(function () { /* el código queda visible para copiar a mano */ });
  });

  /* Suscripción hecha desde la franja: llevar al usuario al bloque de éxito
     (la página vuelve arriba tras el redirect y el código quedaría oculto). */
  if (postedOrigin === 'band') {
    var bandSuccess = document.getElementById('SubscribeBand-success');
    if (bandSuccess) {
      bandSuccess.scrollIntoView({ block: 'center' });
      bandSuccess.focus({ preventScroll: true });
    }
  }

  if (!customElements.get('subscribe-popup')) {
    customElements.define(
      'subscribe-popup',
      class SubscribePopup extends ModalDialog {
        connectedCallback() {
          /* El super portalea el nodo a <body> (re-dispara connectedCallback;
             su guard this.moved corta la recursión) — init una sola vez. */
          super.connectedCallback();
          if (this.initialized) return;
          this.initialized = true;

          // Editor de temas: sin triggers; se previsualiza al seleccionar la sección
          if (this.dataset.designMode === 'true') {
            this.bindDesignMode();
            return;
          }

          // Vuelta del POST hecho desde el popup: reabrir en éxito (con código) o con el error visible
          if (postedOrigin === 'popup') {
            this.classList.add('is-subscribed');
            this.open();
            return;
          }
          if (pendingOrigin === 'popup' && this.querySelector('.fb-subscribe-form__error')) {
            ssRemove(SS_ORIGIN);
            this.open();
            return;
          }

          // QA: apertura forzada
          if (new URLSearchParams(window.location.search).get('fb-popup') === 'open') {
            this.open();
            return;
          }

          // Gates de no-arranque
          if (window.location.pathname.indexOf('/challenge') === 0) return;
          if (lsGet(LS_SUBSCRIBED) === '1') return;
          var dismissed = parseInt(lsGet(LS_DISMISSED), 10);
          var suppressDays = parseInt(this.dataset.suppressDays, 10) || 15;
          if (dismissed && Date.now() - dismissed < suppressDays * DAY_MS) return;

          this.armTriggers();
        }

        disconnectedCallback() {
          this.disarm();
        }

        armTriggers() {
          var mobile = window.matchMedia('(max-width: 749px)').matches;
          if (mobile && this.dataset.showMobile !== 'true') return;
          if (!mobile && this.dataset.showDesktop !== 'true') return;

          var self = this;
          this.cleanups = [];
          var fired = false;
          var fire = function () {
            if (fired) return;
            fired = true;
            self.disarm();
            self.open();
          };

          if (mobile) {
            // Móvil: a los N segundos O al M% de scroll, lo primero que ocurra
            var timer = setTimeout(fire, (parseInt(this.dataset.delayMobile, 10) || 8) * 1000);
            this.cleanups.push(function () { clearTimeout(timer); });
            var target = (parseInt(this.dataset.scrollPercent, 10) || 35) / 100;
            var onScroll = function () {
              var max = document.documentElement.scrollHeight - window.innerHeight;
              if (max > 0 && window.scrollY / max >= target) fire();
            };
            window.addEventListener('scroll', onScroll, { passive: true });
            this.cleanups.push(function () { window.removeEventListener('scroll', onScroll); });
          } else {
            // Desktop: respaldo por tiempo + exit-intent (armado tardío contra falsos positivos)
            var backup = setTimeout(fire, (parseInt(this.dataset.delayDesktop, 10) || 20) * 1000);
            this.cleanups.push(function () { clearTimeout(backup); });
            if (this.dataset.exitIntent === 'true') {
              var onMouseOut = function (event) {
                if (!event.relatedTarget && event.clientY <= 0) fire();
              };
              var armTimer = setTimeout(function () {
                document.addEventListener('mouseout', onMouseOut);
              }, 3000);
              this.cleanups.push(function () {
                clearTimeout(armTimer);
                document.removeEventListener('mouseout', onMouseOut);
              });
            }
          }
        }

        disarm() {
          (this.cleanups || []).forEach(function (fn) { fn(); });
          this.cleanups = [];
        }

        open() {
          if (this.hasAttribute('open')) return;
          // Otro overlay abierto (drawer, lightbox, menú): esperar a que se libere.
          // ModalDialog despacha 'modalClosed' en body; los drawers no, de ahí el poll.
          if (document.body.classList.contains('overflow-hidden')) {
            if (this.waiting) return;
            this.waiting = true;
            var self = this;
            var tryOpen = function () {
              if (document.body.classList.contains('overflow-hidden')) return;
              document.body.removeEventListener('modalClosed', tryOpen);
              clearInterval(poll);
              self.waiting = false;
              self.open();
            };
            document.body.addEventListener('modalClosed', tryOpen);
            var poll = setInterval(tryOpen, 3000);
            return;
          }
          this.loadMedia();
          this.show(null);
        }

        /* La imagen del panel solo se descarga si el popup se va a ver (y solo desktop) */
        loadMedia() {
          if (!window.matchMedia('(min-width: 750px)').matches) return;
          this.querySelectorAll('img[data-fb-src]').forEach(function (img) {
            img.src = img.getAttribute('data-fb-src');
            img.removeAttribute('data-fb-src');
          });
        }

        hide() {
          super.hide();
          // Cerrar (botón, ESC o backdrop) = suprimir N días. En el editor no
          // se escribe: contaminaría la supresión del navegador del comerciante.
          if (this.dataset.designMode !== 'true') lsSet(LS_DISMISSED, String(Date.now()));
        }

        bindDesignMode() {
          var self = this;
          document.addEventListener('shopify:section:select', function (event) {
            if (event.detail.sectionId === self.dataset.section) self.open();
          });
          document.addEventListener('shopify:section:deselect', function (event) {
            if (event.detail.sectionId === self.dataset.section) self.hide();
          });
          // Al re-renderizar la sección en el editor, el nodo ya portaleado a
          // body quedaría huérfano y duplicado: se retira.
          document.addEventListener('shopify:section:unload', function (event) {
            if (event.detail.sectionId === self.dataset.section) self.remove();
          });
        }
      }
    );
  }
})();
